/* eslint-disable react/no-danger */
import React from "react"
import { Image } from "rebass"
import propTypes from "prop-types"
import styled from "styled-components"
import ReactPlayer from "react-player"

import converter from "../converter"
import withTranslation from "../i18n/withTranslation"
import logo from "../assets/logoBalmaceda.svg"

const SlideContainer = styled.div`
  position: relative;
  max-width: 70vw;
  margin: 0 auto;

  .content {
    position: absolute;
    background: white;
    padding: 15px;
    opacity: 0;
    font-weight: lighter;
    transition: all 0.5s ease-in-out;

    img {
      width: 20%;
      padding: 0 10px;
    }

    > div {
      max-width: 70%;
    }

    h1 {
      text-transform: uppercase;
      font-size: 1em;
      margin: 1em 0;
      font-weight: normal;
    }

    &.-BOTTOM {
      bottom: 0;
      width: 100%;
      display: flex;
      justify-content: space-around;
    }

    &.-LEFT,
    &.-RIGHT {
      top: 0;
      max-width: 250px;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
    }

    &.-RIGHT {
      right: 0;
    }

    &.-LEFT {
      left: 0;
    }

    &.-LEFT,
    &.-RIGHT {
      img {
        width: 100px;
      }
    }

    &.-TOP {
      top: 0;
      width: 100%;
    }
  }

  &:hover {
    .content {
      opacity: 1;
    }
  }
`
const PlayerWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
    background: #cccaca;
  }
`

const createMarkup = content => {
  return { __html: content }
}

const SlideItem = ({ data, index, activeSlide, i18n }) => {
  const {
    frontmatter: { display: pos, titleLogo },
  } = data

  const { language } = i18n

  const title =
    language === "es_MX" ? data.frontmatter.titleES : data.frontmatter.title
  const content =
    language === "es_MX"
      ? converter.makeHtml(data.frontmatter.bodyES)
      : data.html

  return (
    <SlideContainer>
      {data.frontmatter.video ? (
        <PlayerWrapper>
          <ReactPlayer
            className="react-player"
            url={data.frontmatter.video}
            playing={activeSlide === index}
            loop
            width="100%"
            height="100%"
            style={{
              width: "100%",
            }}
          />
        </PlayerWrapper>
      ) : (
        <Image src={data.frontmatter.image} />
      )}
      <div className={`content -${pos}`}>
        {titleLogo === "TITLE-NO-LOGO" && titleLogo !== "HIDE-TITLE-LOGO" && (
          <h1>{title}</h1>
        )}

        {titleLogo === "LOGO-NO-TITLE" && titleLogo !== "HIDE-TITLE-LOGO" && (
          <Image src={logo} />
        )}

        <div dangerouslySetInnerHTML={createMarkup(content)} />
      </div>
    </SlideContainer>
  )
}

SlideItem.propTypes = {
  data: propTypes.shape({
    frontmatter: propTypes.shape({
      display: propTypes.string,
      titleLogo: propTypes.string,
      image: propTypes.string,
      video: propTypes.string,
      title: propTypes.string,
      titleES: propTypes.string,
      bodyES: propTypes.string,
    }),
    html: propTypes.string,
  }).isRequired,
  index: propTypes.number.isRequired,
  activeSlide: propTypes.number.isRequired,
  i18n: propTypes.shape({
    language: propTypes.string,
  }).isRequired,
}

export default withTranslation(SlideItem)
